import * as React from "react"
import { Box } from "@mui/material"

import { ActionButton } from "../../@components"
import { useCatalogueDetailsForm } from "../../../@hooks"
import { catalogueDetailsFormIsSkuMappingData } from "../../../@signals"


export default function EditButton({ rowData, isSkuMappingTable }) {
    const { handleOpenForm, isOpenEditDrawer, isLoadingDrawer } = useCatalogueDetailsForm(rowData)

    return <Box componet="span" className={isOpenEditDrawer ? 'is-open' : ''}>
        <ActionButton
            isLoading={isLoadingDrawer}
            label="Edit"
            icon="pen-to-square"
            onClick={() => {
                catalogueDetailsFormIsSkuMappingData.value = isSkuMappingTable
                handleOpenForm()
            }}
        />
    </Box>
}